// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessHammer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.505 4.791c-.565-.06-1.039.092-1.374.441l-4.757 4.956L5.47 11.33l2.437-2.538 9.881 10.293 1.241-1.293L9.15 7.5l2.318-2.416a2.81 2.81 0 0 0-.962-.293zm.194-1.99c.993.105 1.966.566 2.702 1.238.55.5.507 1.332.052 1.806L11.865 7.5l9.032 9.409c.469.488.469 1.28 0 1.768l-2.26 2.353a1.166 1.166 0 0 1-1.696 0l-9.033-9.409-1.588 1.655a1.166 1.166 0 0 1-1.697 0l-2.116-2.204a1.287 1.287 0 0 1 0-1.768l5.266-5.486c.83-.865 1.922-1.123 2.926-1.017z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessHammer;
